import { ModuleType } from "./ModuleType";

export enum FilterMenuType {
  SEARCH_BAR = 1,
  DATERANGE,
  MULTI_SELECT,
  SINGLE_SELECT,
  PRICE_RANGE,
  BOOLEAN,
  DATE,
  LOCAL_SINGLE_SELECT,
  LOCAL_MULTI_SELECT,
  LOCAL_SEARCH_SINGLE_SELECT,
  LOCAL_SEARCH_MULTI_SELECT,
}

export interface FilterSidebarMenu {
  moduleType: ModuleType;
  fieldType: FilterMenuType;
  label: string;
  value?: any;
  list?: any;
  onChange: (value: any) => void;
  subType?: string;
  placeholder?: string;
  inlinePlaceholder?: boolean;
}
